import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { Text } from './Text';
import { sanitizeHtml } from './sanitizeHtml';
import { looksLikeRichText } from './richText';

type RichTextTone = 'primary' | 'secondary';

interface RichTextContentProps {
    content: string;
    tone?: RichTextTone;
}

export function RichTextContent({ content, tone = 'primary' }: RichTextContentProps) {
    if (!looksLikeRichText(content)) {
        return (
            <Text component="p" tone={tone} lineHeight="relaxed" preserveWhitespace>
                {content}
            </Text>
        );
    }
    return <Content $tone={tone} dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }} />;
}

const Content = styled('div', { shouldForwardProp: (p) => p !== '$tone' })<{ $tone: RichTextTone }>(({ $tone }) => ({
    fontSize: 14,
    lineHeight: 1.5,
    color: $tone === 'secondary' ? Colors.textSecondary : Colors.primary,
    overflowWrap: 'break-word',
    '& > :first-of-type': {
        marginTop: 0,
    },
    '& > :last-child': {
        marginBottom: 0,
    },
    '& p': {
        margin: 0,
    },
    '& p:empty': {
        minHeight: '1.5em',
    },
    '& h2': {
        fontSize: 18,
        fontWeight: 600,
        margin: '12px 0 4px',
    },
    '& blockquote': {
        borderLeft: `3px solid ${Colors.border}`,
        margin: '8px 0',
        paddingLeft: 12,
        color: Colors.textSecondary,
    },
    '& a': {
        color: '#2563eb',
        textDecoration: 'underline',
    },
    '& ul, & ol': {
        margin: '0 0 8px',
        paddingLeft: 24,
    },
    '& hr': {
        border: 'none',
        borderTop: `1px solid ${Colors.border}`,
        margin: '12px 0',
    },
}));
